<div class="confirm-dialog-wrapper">
    <div class="icon-container">
        <mat-icon>report_problem</mat-icon>
    </div>

    <div class="text-content">
        <h2 class="title">{{data?.title}}</h2>
        <p class="message">{{data?.message}}</p>
    </div>

    <div class="action-buttons">
        <button mat-stroked-button class="btn-cancel" (click)="onDismiss()">
            {{data?.buttonName1 || 'Cancel'}}
        </button>
        <button mat-flat-button color="warn" class="btn-confirm" (click)="onConfirm()">
            {{data?.buttonName2 || 'Confirm'}}
        </button>
    </div>
</div>